/*
 * The Belgian Brewer: Private hire (sections/tbb-hire.liquid).
 * - Accordion: at 1100px and wider, hover, keyboard focus or a click opens a panel (the others narrow).
 *   Below 1100px every panel is open and the buttons are just headings.
 * - "Enquire" links preselect their space in the form.
 * - Inline validation for name and email before the form posts; after a successful post the
 *   thank-you message is scrolled into view and focused.
 */
function setUpAccordion(root) {
  const accordion = root.querySelector('[data-tbb-accordion]');
  if (!accordion) return;
  const slices = [...accordion.querySelectorAll('[data-tbb-slice]')];
  if (!slices.length) return;
  const wide = window.matchMedia('(min-width: 1100px)');
  let current = accordion.querySelector('.is-open') || slices[0];

  const paint = () =>
    slices.forEach((slice) => {
      slice.classList.toggle('is-open', slice === current);
      slice.querySelector('.tbb-hire__btn')?.setAttribute('aria-expanded', String(!wide.matches || slice === current));
    });
  const open = (slice) => {
    if (slice !== current) {
      current = slice;
      paint();
    }
  };

  slices.forEach((slice) => {
    slice.addEventListener('mouseenter', () => {
      if (wide.matches) open(slice);
    });
    slice.addEventListener('focusin', () => open(slice));
    slice.addEventListener('click', () => open(slice));
  });
  wide.addEventListener('change', paint);
  paint();
}

function setUpForm(root) {
  const form = root.querySelector('form#enquire');
  const select = root.querySelector('[data-tbb-space-select]');

  root.querySelectorAll('[data-tbb-space]').forEach((link) =>
    link.addEventListener('click', () => {
      if (select && [...select.options].some((o) => o.value === link.dataset.tbbSpace)) {
        select.value = link.dataset.tbbSpace;
      }
    })
  );

  const done = root.querySelector('[data-tbb-enquiry-done]');
  if (done) {
    done.scrollIntoView({ block: 'center' });
    done.focus({ preventScroll: true });
  }

  if (!form) return;
  const emailPattern = /^\S+@\S+\.\S+$/;

  form.addEventListener('submit', (event) => {
    let firstInvalid = null;
    form.querySelectorAll('[data-tbb-required]').forEach((field) => {
      const value = field.value.trim();
      const ok = field.type === 'email' ? emailPattern.test(value) : value !== '';
      const message = document.getElementById(field.getAttribute('aria-describedby'));
      field.setAttribute('aria-invalid', String(!ok));
      if (message) message.textContent = ok ? '' : field.dataset.tbbRequired;
      if (!ok && !firstInvalid) firstInvalid = field;
    });
    if (firstInvalid) {
      event.preventDefault();
      firstInvalid.focus();
    }
  });
}

function setUp(root) {
  if (root.dataset.tbbReady) return;
  root.dataset.tbbReady = 'true';
  setUpAccordion(root);
  setUpForm(root);
}

const init = (root = document) => root.querySelectorAll('[data-tbb-hire]').forEach(setUp);
init();
document.addEventListener('shopify:section:load', (event) => init(event.target));
